// extracted by mini-css-extract-plugin
module.exports = {"flights":"XbixSrWu5Oc8","flight":"_3KuENTArSJ01","flight_icon":"_3yYDb0n0n9-f","flight_count":"ZJrKigh_XiMK","flight_info":"_1ansktbp8oek","flight_direction":"pLvEUZBGlf0z"};